import YRecaptcha from './Recaptcha';

export { YRecaptcha };
export default YRecaptcha;
